import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { ConstantsService } from 'app/services/constants-service';
import { ObservableRequestService } from 'app/services/observable-request.service';

@Injectable()
export class ClientsOverviewService {

    constructor(
        private request: ObservableRequestService
    ) { }


    getClients(): Observable<any> {
        return this.request.getRequest(ConstantsService.CLIENTS_ENDPOINT);
    }

}



// WEBPACK FOOTER //
// ./src/app/clients/overview/clients-overview.service.ts